import React from 'react';
import './Home.scss';
import { connect } from 'react-redux';
import PersonalDetailsCard from '../../../components/PersonalDetailsCard/PersonalDetailsCard';
import ActionsCard from '../../../components/ActionsCard/ActionsCard';
import ContactUsCard from '../../../components/ContactUsCard/ContactUsCard';

const Home = () => (
  <div className="logistics-team-home">
    <div className="sidebar">
      <PersonalDetailsCard />
      <ActionsCard />
      <ContactUsCard />
    </div>
    <div className="content card">
      <h4>WIP</h4>
    </div>
  </div>
);

export default connect()(Home);
